import { useEffect } from 'react';

import ErrorTemplate from '@/components/layouts/ErrorTemplate';
import LayoutError from '@/components/layouts/LayoutError';
import { ERROR_MESSAGES } from '@/consts';

import { useLingui } from '@lingui/react';

const NotFound = ({ message }: { message?: string }) => {
  const { i18n } = useLingui();

  const errorMessage = ERROR_MESSAGES[message as keyof typeof ERROR_MESSAGES];

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!import.meta.env.VITE_SHOW_DEV_TOOLS) {
        window.location.href = 'https://helpfind.pl/';
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <LayoutError>
      <ErrorTemplate
        code={404}
        message={errorMessage ?? i18n.t('Nie znaleziono strony')}
      />
    </LayoutError>
  );
};

export default NotFound;
